import { render } from "./oauth-submit.vue?vue&type=template&id=516eae53&scoped=true"
import script from "./oauth-submit.vue?vue&type=script&lang=js"
export * from "./oauth-submit.vue?vue&type=script&lang=js"

import "./oauth-submit.vue?vue&type=style&index=0&id=516eae53&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516eae53"]])

export default __exports__